export default __webpack_public_path__ + "static/media/titleimg.f77a6014.jpg";